import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { AnimatedDonutChart } from '@/components/Charts/AnimatedDonutChart'
import { useUserStore } from '@/store'

export const PortfolioCard: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const wallet = useUserStore((state) => state.wallet)
  const completeCurrencies = wallet?.completeCurrencies || []

  const defaultWallet = completeCurrencies.find(
    (currency) => currency.code === 'USDT',
  )

  const onlyCurrenciesWithAmount = completeCurrencies.filter(
    (currency) => currency.fiatAmount > 0,
  )
  const totalAssets = onlyCurrenciesWithAmount.length

  const handleAddMoney = () => {
    if (!defaultWallet) {
      return
    }
    navigate('/currency-deposit', {
      state: { ...defaultWallet },
    })
  }

  const handleWithdraw = () => {
    if (!defaultWallet) {
      return
    }

    navigate('/withdraw', {
      state: {
        cryptoCode: defaultWallet.code,
        selectedCurrency: defaultWallet,
        from: '/portfolio',
      },
    })
  }

  return (
    <BaseView
      bgColor="background.cardItemRoot"
      rounded={32}
      px={16}
      py={16}
      gap={40}
    >
      {/* Header */}
      <BaseView gap={2}>
        <BaseText fontSize={18} fontFamily="semibold" color="label.default">
          {t('translation:portfolio.portfolioValue')}
        </BaseText>
        <BaseText fontSize={16} fontFamily="medium" color="label.description">
          {t('translation:portfolio.totalAssets')}: {totalAssets}
        </BaseText>
      </BaseView>

      {/* Donut Chart */}
      <BaseView center>
        <AnimatedDonutChart values={onlyCurrenciesWithAmount} />
      </BaseView>

      {/* Action Buttons */}
      <BaseView row gap={12}>
        <BaseView flex={1}>
          <AppButton
            type="secondaryGray"
            size="medium"
            fontFamily="semibold"
            height={56}
            style={{
              borderRadius: 28,
              fontSize: 18,
            }}
            label={t('form:actions.addMoney')}
            onPress={handleAddMoney}
          />
        </BaseView>
        <BaseView flex={1}>
          <AppButton
            type="secondaryGray"
            size="medium"
            fontFamily="semibold"
            height={56}
            style={{
              borderRadius: 28,
              fontSize: 18,
            }}
            label={t('form:actions.withdraw')}
            onPress={handleWithdraw}
          />
        </BaseView>
      </BaseView>
    </BaseView>
  )
}
